import Header from '../header/Header';
import Footer from '../footer/Footer';
import ReviewLink from '../review/Review';
const Reviewpage = () => {
    return (
      <div>
        <Header/>
      <ReviewLink/>
        <Footer/>
      </div>
    )
  }
  
  export default Reviewpage;